import React, { useEffect, useState } from 'react';

// material-ui
import { Box, Button, Card, Grid, Input, Typography, TextareaAutosize, TextField, Switch, FormControlLabel, Checkbox } from '@mui/material';

//project imports
import { TCInput, TCSelect } from 'components/TopCourtComponents/Input/TopCourtInput';
import { TCLabel, TCTitleLabel } from 'components/TopCourtComponents/Label/TopCourtLabel';
import { getParamsFromURL } from 'helper/Params';
// import { getCounter, updateCounter } from 'services/SettingServices';
import { getCourtType, createCourtType, updateCourtType, getSportTypeOptions } from 'services/courtTypeServices';
import { useNavigate } from 'react-router';
import { toast } from 'react-toastify';
import { update } from 'immutable';

export default function AddCourtTypes() {

    const [form, setForm] = useState({
        name: '',
        sportType: null,
        isAllCourt: false
    })
    const [joiForm, setJoiForm] = useState({
        name: null,
        sportType: null
    })
    const [sportTypeOptions, setSportTypeOptions] = useState([])

    const navigate = useNavigate()

    useEffect(() => {
        let { params } = getParamsFromURL(window);
        if (params) getCourtTypeDetail(params)
        loadSportTypeOptions()
    }, [])

    
    useEffect(() => {
        setJoiForm({
            name: form.name ? null : ' required',
            sportType: form.sportType ? null : ' required'
        })
    }, [form])

    const disabledForm = () => {
        return joiForm.name || joiForm.sportType
    }

    const onChange = (e) => {
        setForm(prev => ({
            ...prev,
            ...e
        }))
    }

    const getCourtTypeDetail = async (id) => {
        try {
            let { data, error } = await getCourtType(id)
            if (error) throw error
            if (data) {
                setForm({
                    ...data,
                    sportType: data.sportType ? { value: data.sportType.value, label: data.sportType.name } : null
                })
            }
        } catch (error) {
            console.log(error)
        }
    }

    const loadSportTypeOptions = async () => {
        try {
            let { data, error } = await getSportTypeOptions({
                isActive: true
            })
            if (error) throw error
            if (data) {
                let options = data.map((item) => {
                    return {
                        value: item._id,
                        label: item.name
                    }
                })
                setSportTypeOptions(options)
            }
        } catch (error) {
            console.log(error)
        }
    }

    const updateOrCreate = () => {
        if (form._id) {
            update()
        } else {
            create()
        }
    }
    
    const create = async () =>  {
        try {
            let body = { ...form }
            if (form.sportType) {
                body.sportType = form.sportType ? form.sportType.value : null
            }
            let { data, error } = await createCourtType(body)
            if (error) throw error
            if (data) {
                setForm(data)
                toast('Add Court Type success', {
                    toastId: 'court-type-success',
                    type: 'success',
                });
                navigate('/court-types')
            }
        } catch (error) {
            console.log(error)
        }
    }

    const update = async () => {
        try {
            let body = { ...form }
            if (form.sportType) {
                body.sportType = form.sportType ? form.sportType.value : null
            }
            let { data, error } = await updateCourtType(body)
            if (error) throw error
            if (data) {
                // setForm(data)
                toast('Update Court Type success', {
                    toastId: 'court-type-success',
                    type: 'success',
                });
                getCourtTypeDetail()
                // navigate('/court-types')
            }
        } catch (error) {
            console.log(error)
        }
    }

    return (
        <>
            <Grid item container xs={12} md={12} lg={12}>
                <Grid xs={12} md={6} lg={6} sx={{ p: 1 }}>
                    <Card sx={{ mb: 3 }}>
                        <Box sx={{
                            justifyContent: 'center',
                            alignItems: 'center',
                            marginBottom: 3
                        }}>
                            <Grid container sx={{
                                p: 2, pb: 2
                            }}>
                                <Grid item container xs={12} md={12}>
                                    <Grid xs={12} md={12} sx={{ p: 1 }}>
                                        <TCInput value={form.name} label={"Court Type Name*"} showAlert={joiForm && joiForm.name} onChange={(e) => onChange({ name: e.currentTarget.value.trimStart() })} />
                                    </Grid>
                                    <Grid xs={12} md={12} sx={{ p: 1 }}>
                                        <TCSelect value={form.sportType} options={sportTypeOptions} label={"Sport Type*"} showAlert={joiForm && joiForm.sportType} onChange={(e) => onChange({ sportType: e })}/>
                                    </Grid>
                                    <Grid xs={12} md={12} sx={{ pl: 1, pr: 1 }}>
                                        <FormControlLabel control={<Checkbox id="all-court-checkbox" checked={form.isAllCourt ? true : false} onChange={() => {
                                            onChange({isAllCourt: !form.isAllCourt})
                                        }} />} label={<TCLabel>All Court</TCLabel>} />
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid container direction={"row"} sx={{
                                pl: 3
                            }}>
                                <Button variant="contained" onClick={() => { updateOrCreate() }} disabled={ disabledForm() }>
                                    { form._id ? "Update" : "Add" }
                                </Button>
                            </Grid>
                        </Box>
                    </Card>
                </Grid>
            </Grid>
        </>
    )
}